<template>
  <section :class="{ 'fill-landing': name !== '' }">
    <Landing :booked="booked">
      <div class="ui">
        <Button v-if="name !== '' && !booked" link="#calendar" text="Book Now" @click="$store.state.availableBookings = []; $store.commit('setSelectedBooking', ''); $store.commit('setSelectedSchedule', 'sch-a');" />
      </div>
    </Landing>
    <Expired v-if="expired" />
    <Form v-else-if="name !== '' && !booked && showCalendar" />
  </section>
  <Footer />
</template>

<script>
  import axios from "axios";
  import Button from "@/components/Button";
  import Landing from "@/components/Landing";
  import Form from "@/components/Form";
  import Expired from "@/components/Expired";
  import Footer from "@/components/Footer";

  export default {
    name: "Book",
    components: {
      Button,
      Landing,
      Form,
      Footer,
      Expired
    },
    data() {
      return {
        name: "",
        repEmail: "",
        repPhone: "",
        repName: "",
        schedules: [],
        expired: false,
        booked: false,
        showRepInfo: false,
        showLocationInfo: false,
        photo: '',
        showCalendar: false
      };
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      const params = new URLSearchParams();
      params.append("purl", this.$route.params.purl);
      params.append("appt", '');
      axios
        .post(`${this.$store.state.API}/Purl.php`, params)
        .then(this.onGetPurl);
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      onGetPurl(response) {
        if (response.data.status === "ok") {
          this.name = response.data.first;
          this.repEmail = response.data.repEmail;
          this.repName = `${response.data.repFirst} ${response.data.repLast}`;
          let name = response.data.repLast.replaceAll(' ', '').toLowerCase();
          this.photo = name;
          //${name.split(' ').unshift()
          this.repPhone = response.data.repPhone;
          this.expired = response.data.expired;
          this.booked = response.data.account?.booked ?? false;
          this.$store.commit("setRepId", response.data.id);
          this.$store.commit("setRepPurl", response.data.repPurl);
          this.$store.commit("setClient", response.data.account ?? null);
          let schedules = response.data.schedules ?? []
          this.$store.commit("setSelectedSchedule", schedules[0].value ?? 'sch-a');
          this.showCalendar = true;
        }
      },
      handleScroll(event) {
        if (window.scrollY === 0) {
          document.location.hash = '';
        }
      }
    },
  };
</script>

<style lang="scss" scoped>  
  section {
    display: flex;
    flex-direction: column;

    &:not(.fill-landing) {
      min-height: 100vh;
    }

    &.fill-landing {
      .landing {
        min-height: calc(max(100vh, 900px));
      }
    }
  }

  .ui {    
    >* {
      margin: 0;
    }
  }
</style>